<template>
	<div class="page-wrapper">
		<div class="page-header ms-1 d-flex justify-content-between align-items-center">
			<div>
				<h4 class="m-0">🥳 Welcome back {{ authUser.name }}</h4>
				<small class="text-secondary">This is a small page with great possibilities edited</small>
			</div>

			<div>
				<select class="form-select" @change="getStatistic()" v-model="period">
					<option value="30">Last 30 days</option>
					<option value="60">Last 60 days</option>
					<option value="90">Last 90 days</option>
					<option value="180">Last 180 days</option>
					<option value="365">Last 365 days</option>
				</select>
			</div>
		</div>

		<div class="page-body">
			<div class="row">
				<!-- Town Web Clients -->
				<div class="col-12 col-lg-4 col-xl-4 col-md-4 mb-3">
					<div class="action-card">
						<div class="card-body">
							<div class="card-header-row">
								<div class="card-info">
									<div class="card-icon-wrapper">
										<div class="card-icon">
											<img width="32px" src="https://assets.website-files.com/5fd9ec20a182fdcd717d73c6/609565592369ea97d6feffae_favicon-32x32.png" alt="" />
										</div>
									</div>
									<h5 class="card-title">Town Web Clients</h5>
								</div>
								<div class="card-stats">
									<div class="total-clients">
										<template v-if="!loading">{{ clients.total }}</template>
										<div v-else class="skeleton-number"></div>
									</div>
									<div class="period-info">All Time</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-1 d-none">
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<span class="d-block" style="font-size:11px">Last Town Web client 👏</span>
									🎉<router-link :to="'clients/edit/' + clients.last.id">
										<span class="fw-bold"> {{ clients.last.name }}</span>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- HeyGov Clients -->
				<div class="col-12 col-lg-4 col-xl-4 col-md-4 mb-3">
					<div class="action-card orange">
						<div class="card-body">
							<div class="card-header-row">
								<div class="card-info">
									<div class="card-icon-wrapper">
										<div class="card-icon">
											<img
												width="32px"
												src="https://assets.website-files.com/60c0bf119dbe7a93934b9782/620facbc6de2234d91568600_HeyGov%203.0%20favicon.png"
												alt=""
											/>
										</div>
									</div>
									<h5 class="card-title">HeyGov Clients</h5>
								</div>
								<div class="card-stats">
									<div class="total-clients">
										<template v-if="!loading">{{ clientHG.total }}</template>
										<div v-else class="skeleton-number"></div>
									</div>
									<div class="period-info">All Time</div>
								</div>
							</div>
						</div>
					</div>

					<div class="card mt-1 d-none">
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<span class="d-block" style="font-size:11px">Last HeyGov client 👏</span>
									🎉<router-link :to="'clients/edit/' + clientHG.last.id"
										><span class="fw-bold"> {{ clientHG.last.name }}</span></router-link
									>
								</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Tweak Clients -->
				<div class="col-12 col-lg-4 col-xl-4 col-md-4 mb-3">
					<div class="action-card purple">
						<div class="card-body">
							<div class="card-header-row">
								<div class="card-info">
									<div class="card-icon-wrapper">
										<div class="card-icon">
											<img
												width="32px"
												src="https://assets.website-files.com/5faac18aaf15d45d121eedeb/5faac29ae6b17c64ba34afd5_Tweak%20Logo%201.svg"
												alt=""
											/>
										</div>
									</div>
									<h5 class="card-title">Tweak Clients</h5>
								</div>
								<div class="card-stats">
									<div class="total-clients">
										<template v-if="!loading">{{ clientTK.total }}</template>
										<div v-else class="skeleton-number"></div>
									</div>
									<div class="period-info">All Time</div>
								</div>
							</div>
						</div>
					</div>
					<div class="card mt-1 d-none">
						<div class="card-body">
							<div class="row">
								<div class="col-md-12">
									<span class="d-block" style="font-size:11px">Last Tweak client 👏</span>
									🎉<router-link :to="'clients/edit/' + clientTK.last.id">
										<span class="fw-bold"> {{ clientTK.last.name }}</span>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-12">
					<div class="row">
						<div class="col-xl-8 col-lg-12 col-md-12">
							<!-- Clients Overdue Payments -->
							<div class="col-12 col-lg-12 col-xl-12 col-md-12 mb-3" v-if="isAuth && authUser.permissions.includes('CLIENT_ACCESS')">
								<div class="action-card orange">
									<div class="card-body">
										<div class="section-header d-flex justify-content-between align-items-center mb-3">
											<div class="d-flex align-items-center">
												<div class="card-icon me-3">
													<font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
												</div>
												<h5 class="section-title mb-0">Payment Overdue Clients</h5>
											</div>
											<div class="d-flex align-items-center">
												<button
													v-if="!loadExportingOverdue && exportingOverdueFile === ''"
													@click="exportOverdue()"
													type="submit"
													class="btn btn-sm btn-outline-primary me-2"
												>
													Export
												</button>
												<a
													v-if="!loadExportingOverdue && exportingOverdueFile !== ''"
													@click="downloadExportOverdue()"
													:href="exportingOverdueFile"
													class="btn btn-success btn-sm me-2"
													download
												>
													Download
												</a>

												<button v-if="loadExportingOverdue" class="btn btn-sm btn-outline-primary me-2" type="button" disabled>
													<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
													Loading...
												</button>

												<div class="form-group">
													<select class="form-select form-select-sm" v-model="overduePriorityFilter">
														<option value="">All</option>
														<option value="low">Low</option>
														<option value="medium">Medium</option>
														<option value="high">High</option>
													</select>
												</div>
											</div>
										</div>

										<div class="campaigns-list">
											<template v-if="!loading">
												<div v-if="filteredOverdues.length > 0" class="overdue-list">
													<div class="campaign-item" v-for="overdue in displayedOverdues" :key="overdue.client_id + '-overdue-' + overdue.due_date">
														<div class="campaign-row" @click="goToClient(overdue.client_id)" role="button">
															<div class="campaign-details">
																<h6 class="campaign-name">
																	<span class="campaign-name-link">{{ overdue.name }}</span>
																</h6>
																<small class="campaign-recipients">Client ID: {{ overdue.client_id }} • Due: {{ overdue.due_date }}</small>
															</div>
															<div class="campaign-code">
																<span class="code-label">Overdue:</span>
																<span class="code-value">
																	<span v-if="overdue.overdue_priority == 'high'" class="badge badge-danger bg-danger">
																		{{ overdue.overdue_days }} days
																	</span>
																	<span v-if="overdue.overdue_priority == 'medium'" class="badge badge-warning bg-warning">
																		{{ overdue.overdue_days }} days
																	</span>
																	<span v-if="overdue.overdue_priority == 'low'" class="badge badge-info bg-secondary text-white">
																		{{ overdue.overdue_days }} days
																	</span>
																</span>
															</div>
														</div>
													</div>
													<div class="text-center mt-3" v-if="!showAllOverdues && filteredOverdues.length > 3">
														<button class="btn btn-outline-secondary btn-sm" @click="toggleShowAllOverdues">
															Show More ({{ filteredOverdues.length - 3 }} more)
														</button>
													</div>
													<div class="text-center mt-3" v-if="showAllOverdues && filteredOverdues.length > 3">
														<button class="btn btn-outline-secondary btn-sm" @click="toggleShowAllOverdues">
															Show Less
														</button>
													</div>
												</div>
												<div v-else class="text-center">
													<span class="fs-4">No clients have exceeded the payment deadline</span>
												</div>
											</template>
											<div v-else class="overdue-loading">
												<div class="skeleton-table">
													<div class="skeleton-table-header">
														<div class="skeleton-table-header-cell" style="width: 10%"></div>
														<div class="skeleton-table-header-cell" style="width: 40%"></div>
														<div class="skeleton-table-header-cell" style="width: 25%"></div>
														<div class="skeleton-table-header-cell" style="width: 25%"></div>
													</div>
													<div class="skeleton-table-body">
														<div class="skeleton-table-row" v-for="n in 3" :key="n">
															<div class="skeleton-table-cell" style="width: 10%">
																<div class="skeleton-table-data skeleton-id"></div>
															</div>
															<div class="skeleton-table-cell" style="width: 40%">
																<div class="skeleton-table-data skeleton-name"></div>
															</div>
															<div class="skeleton-table-cell" style="width: 25%">
																<div class="skeleton-table-data skeleton-date"></div>
															</div>
															<div class="skeleton-table-cell" style="width: 25%">
																<div class="skeleton-table-data skeleton-badge"></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Contract expiring in next 90 days -->
							<div class="col-12 col-lg-12 col-xl-12 col-md-12 mb-3" v-if="isAuth && authUser.permissions.includes('CLIENT_ACCESS')">
								<div class="action-card red">
									<div class="card-body">
										<div class="section-header d-flex justify-content-between align-items-center mb-3">
											<div class="d-flex align-items-center">
												<div class="card-icon me-3">
													<font-awesome-icon :icon="['fas', 'signature']" />
												</div>
												<h5 class="section-title mb-0">Contracts Expiring Soon</h5>
											</div>
											<div class="d-flex align-items-center">
												<button
													v-if="!loadExportingExpiring && exportingExpiringFile === ''"
													@click="exportExpiring()"
													type="submit"
													class="btn btn-sm btn-outline-primary me-2"
												>
													Export
												</button>
												<a
													v-if="!loadExportingExpiring && exportingExpiringFile !== ''"
													@click="downloadExportExpiring()"
													:href="exportingExpiringFile"
													class="btn btn-sm btn-success me-2"
													download
												>
													Download
												</a>
												<button v-if="loadExportingExpiring" class="btn btn-sm btn-outline-primary me-2" type="button" disabled>
													<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
													Loading...
												</button>
											</div>
										</div>
										<div class="campaigns-list">
											<template v-if="!loading">
												<div v-if="expiring.length > 0" class="expiring-list">
													<div class="campaign-item" v-for="contract in displayedExpiringContracts" :key="contract.id">
														<div class="campaign-row" @click="goToClient(contract.id)" role="button">
															<div class="campaign-details">
																<h6 class="campaign-name">
																	<span class="campaign-name-link">{{ contract.name }}</span>
																</h6>
																<small class="campaign-recipients">Client ID: {{ contract.id }}</small>
															</div>
															<div class="campaign-info">
																<div class="client-info-tags">
																	<span class="info-tag theme-tag" v-if="contract.theme">
																		<font-awesome-icon :icon="['fas', 'palette']" class="me-1" />
																		{{ contract.theme }}
																	</span>
																	<span class="info-tag cms-tag" v-if="contract.cms">
																		<font-awesome-icon :icon="['fas', 'globe']" class="me-1" />
																		{{ contract.cms }}
																	</span>
																	<span class="info-tag cms-version-tag" v-if="contract.cms_version">
																		<font-awesome-icon :icon="['fas', 'code-branch']" class="me-1" />
																		{{ contract.cms_version }}
																	</span>
																	<span class="info-tag package-tag" v-if="contract.package">
																		<font-awesome-icon :icon="['fas', 'box']" class="me-1" />
																		{{ contract.package }}
																	</span>
																</div>
															</div>
															<div class="campaign-code">
																<span class="code-label">Expires in:</span>
																<span class="code-value">
																	<span v-if="dateDifferenceDays(contract.contract_ends_at) <= 30" class="badge badge-danger bg-danger">
																		{{ dateDifferenceDays(contract.contract_ends_at) }} days
																	</span>
																	<span v-else class="badge badge-warning bg-warning">
																		{{ dateDifferenceDays(contract.contract_ends_at) }} days
																	</span>
																</span>
															</div>
														</div>
													</div>
													<div class="text-center mt-3" v-if="!showAllExpiring && expiring.length > 3">
														<button class="btn btn-outline-secondary btn-sm" @click="toggleShowAllExpiring">
															Show More ({{ expiring.length - 3 }} more)
														</button>
													</div>
													<div class="text-center mt-3" v-if="showAllExpiring && expiring.length > 3">
														<button class="btn btn-outline-secondary btn-sm" @click="toggleShowAllExpiring">
															Show Less
														</button>
													</div>
												</div>
												<div v-else class="text-center">
													<span class="fs-4">No contracts expiring in the next 90 days</span>
												</div>
											</template>
											<div v-else class="contracts-loading">
												<div class="skeleton-table">
													<div class="skeleton-table-header">
														<div class="skeleton-table-header-cell" style="width: 35%"></div>
														<div class="skeleton-table-header-cell" style="width: 30%"></div>
														<div class="skeleton-table-header-cell" style="width: 20%"></div>
														<div class="skeleton-table-header-cell" style="width: 15%"></div>
													</div>
													<div class="skeleton-table-body">
														<div class="skeleton-table-row" v-for="n in 3" :key="n">
															<div class="skeleton-table-cell" style="width: 35%">
																<div class="skeleton-table-data skeleton-name"></div>
																<div class="skeleton-table-data skeleton-subtitle"></div>
															</div>
															<div class="skeleton-table-cell" style="width: 30%">
																<div class="skeleton-table-tags">
																	<div class="skeleton-table-tag"></div>
																	<div class="skeleton-table-tag"></div>
																	<div class="skeleton-table-tag"></div>
																</div>
															</div>
															<div class="skeleton-table-cell" style="width: 20%">
																<div class="skeleton-table-data skeleton-date"></div>
															</div>
															<div class="skeleton-table-cell" style="width: 15%">
																<div class="skeleton-table-data skeleton-badge"></div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Campaign Analytics -->
							<div class="col-12 col-lg-12 col-xl-12 col-md-12 mb-3" v-if="isAuth && authUser.permissions.includes('CAMPAIGN_ACCESS')">
								<div class="action-card purple">
									<div class="card-body">
										<div class="section-header d-flex justify-content-between align-items-center mb-3">
											<div class="d-flex align-items-center">
												<div class="card-icon me-3">
													<font-awesome-icon :icon="['fas', 'chart-line']" />
												</div>
												<h5 class="section-title mb-0">Campaign Analytics</h5>
											</div>
											<div class="header-right d-flex align-items-center">
												<div class="recent-campaigns-header">
													<div class="recent-campaign-header" v-if="lastPostcard.name">
														<span class="campaign-type">Last postcard:</span>
														<router-link class="campaign-link" :to="'/campaigns/edit/' + lastPostcard.id">
															{{ lastPostcard.name }}
														</router-link>
													</div>
													<div class="recent-campaign-header" v-if="lastLetter.name">
														<span class="campaign-type">Last letter:</span>
														<router-link class="campaign-link" :to="'/campaigns/edit/' + lastLetter.id">
															{{ lastLetter.name }}
														</router-link>
													</div>
												</div>
											</div>
										</div>
										<div class="chart-widget">
											<div class="chart-container" v-if="!loading">
												<canvas ref="campaignChart" width="400" height="200"></canvas>
											</div>
											<div class="chart-loader" v-else>
												<div class="loader-content">
													<div class="chart-skeleton-advanced">
														<div class="skeleton-chart-line"></div>
														<div class="skeleton-chart-line"></div>
														<div class="skeleton-chart-line"></div>
														<div class="skeleton-chart-line"></div>
														<div class="skeleton-chart-line"></div>
													</div>
													<div class="loader-text-advanced">
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<span class="loading-text">Loading campaign data</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- Clients by States -->
							<div class="col-12 col-xl-12 col-lg-12 mb-3" v-if="authUser.permissions.includes('CLIENT_DELETE')">
								<div class="action-card">
									<div class="card-body">
										<div class="section-header d-flex justify-content-between align-items-center mb-3">
											<div class="d-flex align-items-center">
												<div class="card-icon me-3">
													<font-awesome-icon :icon="['fas', 'map-marked-alt']" />
												</div>
												<h5 class="section-title mb-0">Client Distribution by States</h5>
											</div>
											<div class="header-right d-flex align-items-center">
												<div class="states-info">
													<div class="state-info-item">
														<img
															width="20px"
															class="me-2"
															src="https://assets.website-files.com/5fd9ec20a182fdcd717d73c6/609565592369ea97d6feffae_favicon-32x32.png"
															alt=""
														/>
														<span class="state-count">{{ clients.totalStates }} states</span>
													</div>
													<div class="state-info-item">
														<img
															width="20px"
															class="me-2"
															src="https://assets.website-files.com/60c0bf119dbe7a93934b9782/620facbc6de2234d91568600_HeyGov%203.0%20favicon.png"
															alt=""
														/>
														<span class="state-count">{{ clientHG.totalStates }} states</span>
													</div>
												</div>
											</div>
										</div>
										<div class="chart-widget">
											<div class="bar-chart-container" v-if="!loading">
												<StatsBarChart :data="clientStatesBarChart" :options="barChartOptions" :height="200" />
											</div>
											<div class="chart-loader" v-else>
												<div class="loader-content">
													<div class="chart-skeleton-bars">
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
													</div>
													<div class="loader-text-advanced">
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<span class="loading-text">Loading client data</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<!-- HeyGov Features Usage -->
							<div class="col-12 col-xl-6 col-lg-6 col-md-12 mb-3">
								<div class="action-card orange">
									<div class="card-body">
										<div class="section-header d-flex justify-content-between align-items-center mb-3">
											<div class="d-flex align-items-center">
												<div class="card-icon me-3">
													<font-awesome-icon :icon="['fas', 'puzzle-piece']" />
												</div>
												<h5 class="section-title mb-0">HeyGov Features Usage</h5>
												<img
													width="20px"
													class="ms-2"
													src="https://assets.website-files.com/60c0bf119dbe7a93934b9782/620facbc6de2234d91568600_HeyGov%203.0%20favicon.png"
													alt=""
												/>
											</div>
										</div>
										<div class="chart-widget">
											<div class="bar-chart-container" v-if="!loading">
												<StatsBarChart :data="hgClientsFeatures" :options="barChartOptions" :height="200" />
											</div>
											<div class="chart-loader" v-else>
												<div class="loader-content">
													<div class="chart-skeleton-bars">
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
														<div class="skeleton-bar-advanced"></div>
													</div>
													<div class="loader-text-advanced">
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<span class="loading-text">Loading features data</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-xl-4 col-lg-12 col-md-12">
							<!-- Contract Calendar -->
							<div class="col-12 mb-3">
								<div class="action-card" style="overflow: hidden;">
									<div class="card-body" style="overflow: hidden; padding: 20px;">
										<div class="calendar-widget">
											<div class="calendar-header">
												<button class="calendar-nav-btn" @click="previousMonth" :disabled="calendarLoading">
													<font-awesome-icon :icon="['fas', 'chevron-left']" />
												</button>
												<h6 class="calendar-month">{{ currentMonthYear }}</h6>
												<button class="calendar-nav-btn" @click="nextMonth" :disabled="calendarLoading">
													<font-awesome-icon :icon="['fas', 'chevron-right']" />
												</button>
											</div>
											<div v-if="!calendarLoading" class="calendar-grid">
												<div class="calendar-weekdays">
													<div class="calendar-weekday" v-for="day in weekdays" :key="day">{{ day }}</div>
												</div>
												<div class="calendar-days">
													<div
														v-for="day in calendarDays"
														:key="day.date"
														class="calendar-day"
														:class="{
															'other-month': day.otherMonth,
															today: day.isToday,
															'has-contracts': day.contracts.length > 0,
														}"
														@mouseenter="showTooltip($event, day)"
														@mouseleave="hideTooltip"
														@click="showDayOverlay(day)"
													>
														<span class="day-number">{{ day.day }}</span>
														<div v-if="day.contracts.length > 0" class="contract-dots">
															<div
																v-for="contract in day.contracts.slice(0, 3)"
																:key="contract.id"
																class="contract-dot"
																:style="{ backgroundColor: getContractColor(contract.type) }"
															></div>
															<div v-if="day.contracts.length > 3" class="more-contracts">+{{ day.contracts.length - 3 }}</div>
														</div>
													</div>
												</div>
											</div>
											<div v-else class="calendar-loader">
												<div class="loader-content">
													<div class="calendar-skeleton">
														<div class="skeleton-calendar-header">
															<div class="skeleton-nav-btn"></div>
															<div class="skeleton-month-title"></div>
															<div class="skeleton-nav-btn"></div>
														</div>
														<div class="skeleton-weekdays">
															<div class="skeleton-weekday" v-for="n in 7" :key="n"></div>
														</div>
														<div class="skeleton-calendar-grid">
															<div class="skeleton-calendar-day" v-for="n in 42" :key="n"></div>
														</div>
													</div>
													<div class="loader-text-advanced">
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<div class="pulse-dot"></div>
														<span class="loading-text">Loading calendar data</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- ADA test — scan any URL on demand, nothing stored -->
							<div class="col-12">
								<div class="action-card green">
									<div class="card-body">
										<div class="card-header-row">
											<div class="card-info">
												<div class="card-icon-wrapper">
													<div class="card-icon">
														<font-awesome-icon :icon="['fas', 'universal-access']" />
													</div>
												</div>
												<div>
													<h5 class="card-title mb-0">ADA test</h5>
													<div class="ada-test-sub">Scan any URL, nothing saved</div>
												</div>
											</div>
											<button type="button" class="ada-test-btn" @click="adaTestOpen = true">
												<font-awesome-icon :icon="['fas', 'play']" class="me-1" /> Test URL
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<UrlTestModal v-if="adaTestOpen" embed-form @close="adaTestOpen = false" />

		<!-- Tooltip -->
		<div v-if="tooltip.visible" class="calendar-tooltip" :style="{ left: tooltip.x + 'px', top: tooltip.y + 'px' }">
			{{ tooltip.content }}
		</div>

		<!-- Day Overlay Modal -->
		<div v-if="dayOverlay.visible" class="calendar-overlay" @click="closeDayOverlay">
			<div class="calendar-overlay-content" @click.stop>
				<div class="overlay-header">
					<h5 class="overlay-title">
						<font-awesome-icon :icon="['fas', 'calendar-alt']" class="me-2" />
						Contracts for {{ dayOverlay.dateFormatted }}
					</h5>
					<button class="overlay-close-btn" @click="closeDayOverlay">
						<font-awesome-icon :icon="['fas', 'times']" />
					</button>
				</div>
				<div class="overlay-body">
					<div v-if="dayOverlay.contracts.length > 0" class="client-list">
						<div v-for="contract in dayOverlay.contracts" :key="contract.id" class="client-item" @click="goToClient(contract.id)">
							<div class="client-info">
								<div class="client-type-indicator" :style="{ backgroundColor: getContractColor(contract.type) }"></div>
								<div class="client-details">
									<h6 class="client-name">{{ contract.name }}</h6>
									<small class="client-meta">
										ID: {{ contract.id }} • Type: {{ contract.type.charAt(0).toUpperCase() + contract.type.slice(1) }} • Contract Start:
										{{ formatDate(contract.contract_start_at) }}
									</small>
								</div>
							</div>
							<div class="client-actions">
								<font-awesome-icon :icon="['fas', 'arrow-right']" class="action-icon" />
							</div>
						</div>
					</div>
					<div v-else class="no-contracts">
						<font-awesome-icon :icon="['fas', 'calendar-times']" class="empty-icon" />
						<p>No contracts found for this date</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import StatsBarChart from '@/components/charts/StatsBarChart'
import { mapGetters, mapState } from 'vuex'
import { differenceInDays } from 'date-fns'
import restApi from '../api/index'
import Chart from 'chart.js/auto'
import UrlTestModal from '@/components/juniper/ada-auditor/UrlTestModal.vue'
export default {
	name: 'Home',
	data() {
		return {
			loading: false,
			period: 30,
			hgClientsFeatures: {
				labels: ['Hey311', 'HeyLicense', 'HeyEvents', 'HeyForms', 'HeyCalendar', 'HeyPay'],
				datasets: [
					{
						label: 'Feature Usage',
						backgroundColor: ['#8b5cf6', '#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#6366f1'],
						borderColor: ['#8b5cf6', '#3b82f6', '#f59e0b', '#10b981', '#ef4444', '#6366f1'],
						borderWidth: 0,
						borderRadius: 4,
						data: [145, 95, 75, 120, 85, 45],
					},
				],
			},
			campaignsChartPie: {
				labels: ['Postcards', 'Letters'],
				datasets: [
					{
						label: 'Campaigns',
						backgroundColor: ['#f87979', 'ff2123'],
						data: [0, 0],
					},
				],
			},
			campaignsLineChart: {
				labels: ['jan', 'feb'],
				datasets: [
					{
						label: 'Deliveries',
						backgroundColor: '#dedede',
						borderColor: '#2196f3',
						data: [1, 2],
					},
				],
			},
			clientStatesBarChart: {
				labels: ['WI'],
				datasets: [
					{
						label: 'Town Web clients',
						backgroundColor: '#ef4444',
						borderColor: '#ef4444',
						borderWidth: 0,
						borderRadius: 4,
						data: [200],
					},
					{
						label: 'HeyGov clients',
						backgroundColor: '#f97316',
						borderColor: '#f97316',
						borderWidth: 0,
						borderRadius: 4,
						data: [200],
					},
				],
			},
			HGclientStatesBarChart: {
				labels: ['WI'],
				datasets: [
					{
						label: 'Clients',
						backgroundColor: '#fdbd4e',
						borderColor: '#5e81f4',
						data: [200],
					},
				],
			},
			clients: {
				total: 0,
				new: 0,
				lost: 0,
				last: '',
				totalStates: 0,
			},
			clientHG: {
				total: 0,
				new: 0,
				lost: 0,
				last: '',
				totalStates: 0,
			},
			clientTK: {
				total: 0,
				new: 0,
				lost: 0,
				last: '',
				totalStates: 0,
			},
			expiring: [],
			overdues: [],
			exportingOverdueFile: '',
			overduePriorityFilter: '',
			loadExportingOverdue: false,
			exportingExpiringFile: '',
			loadExportingExpiring: false,
			showAllExpiring: false,
			showAllOverdues: false,
			lastPostcard: {},
			lastLetter: {},
			campaignChart: null,
			currentDate: new Date(),
			weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
			contractsData: [],
			calendarLoading: true,
			// Ad-hoc ADA scan of any URL — the modal owns the form and the result.
			adaTestOpen: false,
			tooltip: {
				visible: false,
				x: 0,
				y: 0,
				content: '',
			},
			dayOverlay: {
				visible: false,
				date: '',
				dateFormatted: '',
				contracts: [],
			},
			barChartOptions: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: true,
						position: 'top',
						labels: {
							boxWidth: 12,
							font: {
								size: 12,
							},
							padding: 20,
							usePointStyle: true,
							color: '#6b7280',
						},
					},
					tooltip: {
						backgroundColor: 'rgba(0, 0, 0, 0.8)',
						titleColor: 'white',
						bodyColor: 'white',
						borderColor: 'rgba(255, 255, 255, 0.1)',
						borderWidth: 1,
						cornerRadius: 8,
						displayColors: true,
						callbacks: {
							label: function(context) {
								return `${context.dataset.label}: ${context.parsed.y} clients`
							},
						},
					},
				},
				scales: {
					x: {
						display: true,
						grid: {
							display: false,
						},
						ticks: {
							font: {
								size: 12,
							},
							color: '#6b7280',
						},
					},
					y: {
						display: true,
						grid: {
							color: 'rgba(255, 255, 255, 0.1)',
							borderDash: [2, 2],
						},
						ticks: {
							font: {
								size: 12,
							},
							color: '#6b7280',
						},
					},
				},
			},
			lineChartOptions: {
				responsive: true,
				maintainAspectRatio: true,
				scales: {
					x: {
						grid: {
							display: false,
						},
					},
				},
			},
		}
	},
	components: {
		StatsBarChart,
		UrlTestModal,
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
		...mapGetters(['isAuth']),
		periodString: function() {
			return 'Last ' + this.period + ' days'
		},
		displayedExpiringContracts() {
			return this.showAllExpiring ? this.expiring : this.expiring.slice(0, 3)
		},
		filteredOverdues() {
			if (this.overduePriorityFilter === '') {
				return this.overdues
			}
			return this.overdues.filter(o => o.overdue_priority === this.overduePriorityFilter)
		},
		displayedOverdues() {
			return this.showAllOverdues ? this.filteredOverdues : this.filteredOverdues.slice(0, 3)
		},
		currentMonthYear() {
			const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
			return `${months[this.currentDate.getMonth()]} ${this.currentDate.getFullYear()}`
		},
		calendarDays() {
			const year = this.currentDate.getFullYear()
			const month = this.currentDate.getMonth()
			const firstDay = new Date(year, month, 1)
			const startDate = new Date(firstDay)
			startDate.setDate(startDate.getDate() - firstDay.getDay())

			const days = []
			const today = new Date()

			for (let i = 0; i < 42; i++) {
				const currentDay = new Date(startDate)
				currentDay.setDate(startDate.getDate() + i)

				const dayContracts = this.getContractsForDay(currentDay)

				days.push({
					date: `${currentDay.getFullYear()}-${String(currentDay.getMonth() + 1).padStart(2, '0')}-${String(currentDay.getDate()).padStart(2, '0')}`,
					day: currentDay.getDate(),
					otherMonth: currentDay.getMonth() !== month,
					isToday: currentDay.toDateString() === today.toDateString(),
					contracts: dayContracts,
				})
			}

			return days
		},
	},

	watch: {},

	created() {
		this.getOverdues()
		this.getStatistic()
		this.loadContractsData()
	},

	mounted() {
		this.initializeCampaignChart()
	},

	beforeDestroy() {
		if (this.campaignChart) {
			this.campaignChart.destroy()
		}
	},

	methods: {
		// Get statistic for dashboard
		getStatistic() {
			this.loading = true
			let params = {
				period: this.period,
			}
			restApi
				.get(`/statistic`, { params: params })
				.then(({ data }) => {
					this.campaignsChartPie.datasets[0].data[0] = data.postcards
					this.campaignsChartPie.datasets[0].data[1] = data.letters
					this.clients.total = data.total_clients
					this.clients.new = data.new_clients
					this.clients.lost = data.lost_clients
					this.clients.last = data.last_client

					this.expiring = data.expiring
					this.clientHG.total = data.total_clients_hg
					this.clientHG.new = data.new_clients_hg
					this.clientHG.lost = data.lost_clients_hg
					this.clientHG.last = data.last_client_hg

					this.clientTK.total = data.total_clients_tk
					this.clientTK.new = data.new_clients_tk
					this.clientTK.lost = data.lost_clients_tk
					this.clientTK.last = data.last_client_tk

					this.lastPostcard = data.last_postcard
					this.lastLetter = data.last_letter
					this.campaignsLineChart.labels = data.deliveries.labels
					this.campaignsLineChart.datasets[0].data = data.deliveries.dataset
					this.clientStatesBarChart.labels = data.clients_by_state.labels
					this.clientStatesBarChart.datasets[0].data = data.clients_by_state.dataset
					this.clientStatesBarChart.datasets[1].data = data.hg_clients_by_state.dataset
					this.HGclientStatesBarChart.labels = data.hg_clients_by_state.labels
					this.HGclientStatesBarChart.datasets[0].data = data.hg_clients_by_state.dataset
					this.clientHG.totalStates = data.hg_clients_by_state.total_states
					this.clients.totalStates = data.clients_by_state.total_states

					this.hgClientsFeatures.datasets[0].data = data.hg_clients_features.dataset
					this.hgClientsFeatures.labels = data.hg_clients_features.labels
					this.loading = false
					this.updateCampaignChart()
				})
				.catch(() => {})
		},

		getOverdues() {
			restApi
				.get(`/statistic/payment-overdue`, {})
				.then(({ data }) => {
					this.overdues = data
				})
				.catch(() => {})
		},

		exportOverdue() {
			this.loadExportingOverdue = true
			let data = []
			this.filteredOverdues.forEach(over => {
				data.push(over)
			})
			let params = {
				priority: this.overduePriorityFilter,
				data: data,
			}
			restApi
				.post(`/statistic/export-overdue`, { params })
				.then(({ data }) => {
					this.loadExportingOverdue = false
					this.exportingOverdueFile = this.storageUrl + '/tmp/' + data.file
				})
				.catch(() => {
					this.$swal.fire({
						icon: 'error',
						title: 'Error generating export!',
						timer: 6000,
					})
				})
		},

		downloadExportOverdue() {
			this.exportingOverdueFile = ''
		},

		exportExpiring() {
			this.loadExportingExpiring = true
			let params = {
				data: this.expiring,
			}
			restApi
				.post(`/statistic/export-expiring`, { params })
				.then(({ data }) => {
					this.loadExportingExpiring = false
					this.exportingExpiringFile = this.storageUrl + '/tmp/' + data.file
				})
				.catch(() => {
					this.$swal.fire({
						icon: 'error',
						title: 'Error generating export!',
						timer: 6000,
					})
				})
		},

		downloadExportExpiring() {
			this.loadExportingExpiring = ''
		},

		goToClient(id) {
			this.$router.push('/clients/edit/' + id)
		},

		dateDifferenceDays(date) {
			return differenceInDays(new Date(date), new Date())
		},

		toggleShowAllExpiring() {
			this.showAllExpiring = !this.showAllExpiring
		},

		toggleShowAllOverdues() {
			this.showAllOverdues = !this.showAllOverdues
		},

		initializeCampaignChart() {
			this.$nextTick(() => {
				if (this.$refs.campaignChart) {
					const ctx = this.$refs.campaignChart.getContext('2d')
					this.campaignChart = new Chart(ctx, {
						type: 'line',
						data: {
							labels: this.campaignsLineChart.labels,
							datasets: [
								{
									label: 'Total Sent',
									data: this.campaignsLineChart.datasets[0].data,
									borderColor: '#8b5cf6',
									backgroundColor: 'rgba(139, 92, 246, 0.1)',
									borderWidth: 2,
									fill: true,
									tension: 0.4,
									pointBackgroundColor: '#8b5cf6',
									pointBorderColor: '#ffffff',
									pointBorderWidth: 2,
									pointRadius: 4,
									pointHoverRadius: 6,
								},
							],
						},
						options: {
							responsive: true,
							maintainAspectRatio: false,
							plugins: {
								legend: {
									display: false,
								},
								tooltip: {
									callbacks: {
										label: function(context) {
											return `Sent: ${context.parsed.y}`
										},
									},
								},
							},
							scales: {
								x: {
									display: true,
									grid: {
										display: false,
									},
									ticks: {
										font: {
											size: 12,
										},
									},
								},
								y: {
									display: true,
									grid: {
										color: '#f3f4f6',
										borderDash: [5, 5],
									},
									ticks: {
										font: {
											size: 12,
										},
									},
								},
							},
						},
					})
				}
			})
		},

		updateCampaignChart() {
			if (this.campaignChart) {
				this.campaignChart.destroy()
			}
			this.initializeCampaignChart()
		},

		// Calendar methods
		previousMonth() {
			if (!this.calendarLoading) {
				this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1)
			}
		},

		nextMonth() {
			if (!this.calendarLoading) {
				this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1)
			}
		},

		getContractsForDay(date) {
			const dateString = date.toISOString().split('T')[0]
			return this.contractsData.filter(contract => {
				const contractDate = new Date(contract.contract_start_at).toISOString().split('T')[0]
				return contractDate === dateString
			})
		},

		getContractColor(type) {
			const colors = {
				townweb: '#3b82f6',
				heygov: '#f59e0b',
				tweak: '#8b5cf6',
				default: '#6b7280',
			}
			return colors[type] || colors.default
		},

		showTooltip(event, day) {
			if (day.contracts.length > 0) {
				const rect = event.target.getBoundingClientRect()
				const contractNames = day.contracts.map(c => c.name).join(', ')
				this.tooltip = {
					visible: true,
					x: rect.left + rect.width / 2,
					y: rect.top - 10,
					content: `Contracts: ${contractNames}`,
				}
			}
		},

		hideTooltip() {
			this.tooltip.visible = false
		},

		loadContractsData() {
			this.calendarLoading = true
			restApi
				.get('/clients', { params: { perPage: 100000 } })
				.then(({ data }) => {
					console.log(data)
					this.contractsData = data.data
						.map(client => ({
							id: client.id,
							name: client.name,
							contract_start_at: client.contract_start_at,
							type: this.getClientType(client),
						}))
						.filter(client => client.contract_start_at)
					this.calendarLoading = false
				})
				.catch(error => {
					console.error('Error loading contracts data:', error)
					// Fallback to sample data if API fails
					this.contractsData = [
						{
							id: 1,
							name: 'Sample Client 1',
							contract_start_at: '2025-01-15',
							type: 'townweb',
						},
						{
							id: 2,
							name: 'Sample Client 2',
							contract_start_at: '2025-01-20',
							type: 'heygov',
						},
						{
							id: 3,
							name: 'Sample Client 3',
							contract_start_at: '2025-01-25',
							type: 'tweak',
						},
					]
					this.calendarLoading = false
				})
		},

		getClientType(client) {
			// Determine client type based on available data
			if (client.brand === 'heygov' || client.type === 'heygov') {
				return 'heygov'
			} else if (client.brand === 'tweak' || client.type === 'tweak') {
				return 'tweak'
			} else {
				return 'townweb'
			}
		},

		showDayOverlay(day) {
			if (day.contracts.length > 0) {
				this.dayOverlay = {
					visible: true,
					date: day.date,
					dateFormatted: this.formatDateForDisplay(day.date),
					contracts: day.contracts,
				}
			}
		},

		closeDayOverlay() {
			this.dayOverlay.visible = false
		},

		formatDate(dateString) {
			const date = new Date(dateString)
			return date.toLocaleDateString('en-US', {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
			})
		},

		formatDateForDisplay(dateString) {
			// Parse the date string as local time to avoid timezone issues
			const [year, month, day] = dateString.split('-')
			const date = new Date(year, month - 1, day)
			return date.toLocaleDateString('en-US', {
				weekday: 'long',
				year: 'numeric',
				month: 'long',
				day: 'numeric',
			})
		},
	},
}
</script>

<style scoped lang="scss">
.tableFixHead table {
	border-collapse: collapse;
	width: 100%;
}

.tableFixHead table th,
.tableFixHead table td {
	background: #fff;
}

.tableFixHead {
	overflow: auto;
	height: 204px;
}

.tableFixHead thead th {
	position: sticky;
	top: 0;
}

/* Action Cards */
.action-card {
	border-radius: 14px;
	background: linear-gradient(180deg, var(--Blue-50, #ebf1ff) 0%, var(--Surfaces-surface, #fff) 50%);
	padding: 0;
	height: 100%;
	transition: all 0.3s ease;
	position: relative;
	border: none;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.action-card.orange {
	background: linear-gradient(180deg, #fed7aa 0%, var(--Surfaces-surface, #fff) 50%);
}

.action-card.purple {
	background: linear-gradient(180deg, #e9d5ff 0%, var(--Surfaces-surface, #fff) 50%);
}

.action-card:hover {
	transform: translateY(-2px);
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.action-card .card-body {
	padding: 20px;
	height: 100%;
	display: flex;
	flex-direction: column;
	position: relative;
}

.card-header-row {
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}

.card-info {
	display: flex;
	align-items: center;
	gap: 12px;
}

.card-icon-wrapper {
	margin: 0;
}

.card-icon {
	width: 48px;
	height: 48px;
	border-radius: 12px;
	background-color: transparent;
	border: 1px solid #ebf1ff;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	font-size: 20px;
}

.action-card.orange .card-icon {
	background-color: transparent;
	border-color: #fed7aa;
}

.action-card.purple .card-icon {
	background-color: transparent;
	border-color: #e9d5ff;
}

.action-card.green {
	background: linear-gradient(180deg, #bbf7d0 0%, var(--Surfaces-surface, #fff) 50%);
}

.action-card.green .card-icon {
	background-color: #10b981;
	border-color: #10b981;
	color: white;
}

.action-card.red {
	background: linear-gradient(180deg, #fecaca 0%, var(--Surfaces-surface, #fff) 50%);
}

.action-card.red .card-icon {
	background-color: #ef4444;
	border-color: #ef4444;
	color: white;
}

.card-title {
	font-size: 18px;
	font-weight: 600;
	color: #111827;
	margin: 0;
	line-height: 1.3;
}

.card-stats {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	text-align: right;
}

.total-clients {
	font-size: 2rem;
	font-weight: 700;
	color: #3b82f6;
	line-height: 1.2;
	margin-bottom: 4px;
}

.period-info {
	font-size: 0.75rem;
	color: #6b7280;
	margin: 0;
}

/* Campaign Lists */
.campaigns-list {
	margin-top: 0;
}

.campaign-item {
	padding: 1rem 0;
	border-bottom: 1px solid #f1f5f9;
}

.campaign-item:last-child {
	border-bottom: none;
}

.campaign-row {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 1rem;
	cursor: pointer;
	transition: background-color 0.2s ease;
}

.campaign-row:hover {
	background-color: rgba(0, 0, 0, 0.02);
	border-radius: 8px;
	padding: 0.5rem;
	margin: -0.5rem;
}

.campaign-details {
	flex: 1;
	min-width: 0;
}

.campaign-info {
	flex: 1;
	min-width: 0;
	display: flex;
	justify-content: flex-end;
	margin-right: 1rem;
}

.campaign-name {
	font-size: 1rem;
	font-weight: 600;
	color: #1f2937;
	margin-bottom: 0.25rem;
}

.campaign-name-link {
	color: #1f2937;
	text-decoration: none;
	transition: color 0.3s ease;
}

.campaign-name-link:hover {
	color: #3b82f6;
	text-decoration: underline;
}

.campaign-recipients {
	color: #6b7280;
	font-size: 0.875rem;
}

.campaign-code {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	text-align: right;
	min-width: 120px;
}

.code-label {
	font-size: 0.75rem;
	color: #6b7280;
	font-weight: 500;
	margin-bottom: 0.25rem;
}

.code-value {
	font-size: 0.875rem;
	color: #1f2937;
	font-weight: 600;
}

.section-header {
	margin-bottom: 1.5rem;
}

.section-title {
	font-size: 1.25rem;
	font-weight: 600;
	color: #1f2937;
	margin-bottom: 0.5rem;
}

.badge {
	padding: 4px 8px;
	border-radius: 12px;
	font-size: 12px;
	font-weight: 600;
	color: white;
	cursor: default;
}

.badge-danger {
	background-color: #ef4444;
}

.badge-warning {
	background-color: #f59e0b;
}

/* Client Info Tags */
.client-info-tags {
	display: flex;
	gap: 4px;
	margin-top: 0;
	flex-wrap: wrap;
	justify-content: flex-end;
}

.info-tag {
	display: inline-flex;
	align-items: center;
	padding: 2px 6px;
	border-radius: 4px;
	font-size: 0.6rem;
	font-weight: 500;
	color: white;
	background-color: #6b7280;
}

.theme-tag {
	background-color: #8b5cf6;
}

.cms-tag {
	background-color: #3b82f6;
}

.cms-version-tag {
	background-color: #f59e0b;
}

.package-tag {
	background-color: #10b981;
}

.info-tag svg {
	font-size: 0.56rem;
}

/* Chart Section */
.chart-widget {
	margin-top: 0;
}

.chart-container {
	height: 250px;
	position: relative;
	margin-bottom: 1rem;
	border-radius: 8px;
}

.chart-loader {
	height: 250px;
	position: relative;
	margin-bottom: 1rem;
	border-radius: 8px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.05);
}

.loader-content {
	text-align: center;
	color: rgba(255, 255, 255, 0.8);
}

.chart-skeleton {
	width: 300px;
	height: 150px;
	margin-bottom: 1rem;
	position: relative;
}

.skeleton-line {
	height: 2px;
	background: rgba(255, 255, 255, 0.2);
	border-radius: 2px;
	margin: 8px 0;
	animation: skeleton-loading 1.5s ease-in-out infinite;
}

.skeleton-line:nth-child(1) {
	width: 80%;
}
.skeleton-line:nth-child(2) {
	width: 60%;
}
.skeleton-line:nth-child(3) {
	width: 90%;
}
.skeleton-line:nth-child(4) {
	width: 70%;
}
.skeleton-line:nth-child(5) {
	width: 50%;
}

@keyframes skeleton-loading {
	0% {
		opacity: 0.3;
		transform: translateX(-100%);
	}
	50% {
		opacity: 0.8;
		transform: translateX(0%);
	}
	100% {
		opacity: 0.3;
		transform: translateX(100%);
	}
}

@keyframes skeleton-shimmer {
	0% {
		background-position: -200px 0;
	}
	100% {
		background-position: calc(200px + 100%) 0;
	}
}

@keyframes pulse-animation {
	0% {
		opacity: 0.4;
		transform: scale(0.95);
	}
	50% {
		opacity: 1;
		transform: scale(1);
	}
	100% {
		opacity: 0.4;
		transform: scale(0.95);
	}
}

@keyframes wave-animation {
	0% {
		transform: scaleY(0.4);
	}
	50% {
		transform: scaleY(1);
	}
	100% {
		transform: scaleY(0.4);
	}
}

.loader-text {
	font-size: 0.875rem;
	color: rgba(255, 255, 255, 0.8);
	display: flex;
	align-items: center;
	justify-content: center;
}

/* Header Section */
.header-right {
	display: flex;
	align-items: center;
	gap: 1rem;
}

.recent-campaigns-header {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	text-align: right;
}

.recent-campaign-header {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: flex-end;
}

.campaign-type {
	font-size: 0.7rem;
	color: rgba(255, 255, 255, 0.7);
	font-weight: 500;
	white-space: nowrap;
}

.campaign-link {
	font-size: 0.7rem;
	color: #6b46c1;
	text-decoration: none;
	font-weight: 600;
	white-space: nowrap;
}

.campaign-link:hover {
	color: #553c9a;
	text-decoration: underline;
}

/* States Info */
.states-info {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	text-align: right;
}

.state-info-item {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: flex-end;
}

.state-count {
	font-size: 0.75rem;
	color: #6b7280;
	font-weight: 600;
	white-space: nowrap;
}

/* Bar Chart Container */
.bar-chart-container {
	background: rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	padding: 1rem;
	margin: 0;
	overflow: hidden;
	position: relative;
	height: 250px;
}

/* Bar Chart Skeleton */
.skeleton-bar {
	height: 20px;
	background: rgba(59, 130, 246, 0.2);
	border-radius: 4px;
	margin: 4px 0;
	animation: skeleton-loading 1.5s ease-in-out infinite;
}

.skeleton-bar:nth-child(1) {
	width: 90%;
}
.skeleton-bar:nth-child(2) {
	width: 70%;
}
.skeleton-bar:nth-child(3) {
	width: 85%;
}
.skeleton-bar:nth-child(4) {
	width: 60%;
}
.skeleton-bar:nth-child(5) {
	width: 75%;
}

/* Enhanced Skeleton Components */
.skeleton-number {
	width: 60px;
	height: 32px;
	background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 8px;
	position: relative;
	overflow: hidden;
}

.skeleton-list {
	padding: 0;
}

.skeleton-list-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	gap: 1rem;
}

.skeleton-list-content {
	flex: 1;
	min-width: 0;
}

.skeleton-list-title {
	width: 70%;
	height: 20px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
	margin-bottom: 8px;
}

.skeleton-list-subtitle {
	width: 50%;
	height: 14px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-list-info {
	display: flex;
	gap: 4px;
	flex-wrap: wrap;
	justify-content: flex-end;
	margin-right: 1rem;
}

.skeleton-tag {
	width: 40px;
	height: 18px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-list-badge {
	width: 80px;
	height: 24px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 12px;
	min-width: 80px;
}

/* Advanced Chart Skeletons */
.chart-skeleton-advanced {
	width: 300px;
	height: 150px;
	margin-bottom: 1rem;
	position: relative;
	display: flex;
	align-items: end;
	justify-content: space-between;
	padding: 0 20px;
}

.skeleton-chart-line {
	width: 100%;
	height: 2px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 2px;
	margin: 8px 0;
	position: relative;
}

.skeleton-chart-line::before {
	content: '';
	position: absolute;
	width: 6px;
	height: 6px;
	background: rgba(128, 128, 128, 0.4);
	border-radius: 50%;
	left: 10%;
	top: -2px;
	animation: pulse-animation 2s infinite;
}

.skeleton-chart-line::after {
	content: '';
	position: absolute;
	width: 6px;
	height: 6px;
	background: rgba(128, 128, 128, 0.4);
	border-radius: 50%;
	right: 10%;
	top: -2px;
	animation: pulse-animation 2s infinite 0.5s;
}

.chart-skeleton-bars {
	display: flex;
	align-items: end;
	justify-content: space-between;
	height: 120px;
	width: 100%;
	padding: 0 20px;
	margin-bottom: 1rem;
}

.skeleton-bar-advanced {
	width: 20px;
	background: linear-gradient(0deg, rgba(128, 128, 128, 0.4) 0%, rgba(128, 128, 128, 0.2) 100%);
	border-radius: 4px 4px 0 0;
	animation: wave-animation 2s infinite;
	transform-origin: bottom;
}

.skeleton-bar-advanced:nth-child(1) {
	height: 80%;
	animation-delay: 0s;
}

.skeleton-bar-advanced:nth-child(2) {
	height: 60%;
	animation-delay: 0.2s;
}

.skeleton-bar-advanced:nth-child(3) {
	height: 90%;
	animation-delay: 0.4s;
}

.skeleton-bar-advanced:nth-child(4) {
	height: 70%;
	animation-delay: 0.6s;
}

.skeleton-bar-advanced:nth-child(5) {
	height: 50%;
	animation-delay: 0.8s;
}

.skeleton-bar-advanced:nth-child(6) {
	height: 65%;
	animation-delay: 1s;
}

/* Advanced Loading Text */
.loader-text-advanced {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	font-size: 0.875rem;
	color: rgba(255, 255, 255, 0.8);
}

.pulse-dot {
	width: 6px;
	height: 6px;
	background: rgba(128, 128, 128, 0.6);
	border-radius: 50%;
	animation: pulse-animation 1.5s infinite;
}

.pulse-dot:nth-child(1) {
	animation-delay: 0s;
}

.pulse-dot:nth-child(2) {
	animation-delay: 0.2s;
}

.pulse-dot:nth-child(3) {
	animation-delay: 0.4s;
}

.loading-text {
	margin-left: 8px;
	font-weight: 500;
	opacity: 0.9;
}

/* Table Skeleton Loading */
.skeleton-table {
	width: 100%;
	border-collapse: collapse;
	margin: 1rem 0;
}

.skeleton-table-header {
	display: flex;
	width: 100%;
	padding: 1rem;
	border-bottom: 1px solid rgba(128, 128, 128, 0.2);
	background: rgba(128, 128, 128, 0.1);
}

.skeleton-table-header-cell {
	padding: 0 0.5rem;
	display: flex;
	align-items: center;
}

.skeleton-table-header-cell::before {
	content: '';
	width: 80%;
	height: 16px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-table-body {
	display: flex;
	flex-direction: column;
}

.skeleton-table-row {
	display: flex;
	width: 100%;
	padding: 1rem;
	border-bottom: 1px solid rgba(128, 128, 128, 0.1);
	align-items: center;
	min-height: 70px;
}

.skeleton-table-row:hover {
	background: rgba(128, 128, 128, 0.02);
}

.skeleton-table-cell {
	padding: 0 0.5rem;
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 0.5rem;
}

.skeleton-table-data {
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-id {
	width: 30px;
	height: 16px;
}

.skeleton-name {
	width: 90%;
	height: 18px;
	margin-bottom: 4px;
}

.skeleton-subtitle {
	width: 70%;
	height: 14px;
}

.skeleton-date {
	width: 80%;
	height: 16px;
}

.skeleton-badge {
	width: 60px;
	height: 24px;
	border-radius: 12px;
}

.skeleton-table-tags {
	display: flex;
	gap: 4px;
	flex-wrap: wrap;
}

.skeleton-table-tag {
	width: 40px;
	height: 18px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-table-tag:nth-child(1) {
	animation-delay: 0s;
}

.skeleton-table-tag:nth-child(2) {
	animation-delay: 0.2s;
}

.skeleton-table-tag:nth-child(3) {
	animation-delay: 0.4s;
}

/* Responsive table skeleton */
@media (max-width: 768px) {
	.skeleton-table-row {
		flex-direction: column;
		align-items: flex-start;
		gap: 0.5rem;
	}

	.skeleton-table-cell {
		width: 100% !important;
	}

	.skeleton-table-header {
		display: none;
	}
}

/* Features Info */
.features-info {
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	text-align: right;
}

.feature-info-item {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	justify-content: flex-end;
}

.feature-count {
	font-size: 0.75rem;
	color: rgba(255, 255, 255, 0.8);
	font-weight: 600;
	white-space: nowrap;
}

/* Calendar Styles */
.ada-test-sub {
	font-size: 12px;
	color: #6b7280;
	margin-top: 2px;
}

.ada-test-btn {
	display: inline-flex;
	align-items: center;
	background: transparent;
	border: 1px solid #bbf7d0;
	border-radius: 8px;
	color: #2b303b;
	font-size: 0.8rem;
	font-weight: 600;
	padding: 0.35rem 0.75rem;
	white-space: nowrap;
	transition: background 0.15s ease;
}

.ada-test-btn:hover {
	background: #f0fdf4;
}

.calendar-widget {
	background: rgba(255, 255, 255, 0.05);
	border-radius: 8px;
	padding: 1rem;
	margin-top: 1rem;
	overflow: hidden;
	width: 100%;
	box-sizing: border-box;
}

.calendar-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.calendar-nav-btn {
	background: rgba(255, 255, 255, 0.1);
	border: none;
	border-radius: 50%;
	width: 32px;
	height: 32px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #6b7280;
	cursor: pointer;
	transition: all 0.2s ease;
}

.calendar-nav-btn:hover {
	background: rgba(255, 255, 255, 0.2);
	color: #374151;
}

.calendar-month {
	font-size: 1.1rem;
	font-weight: 600;
	color: #374151;
	margin: 0;
}

.calendar-grid {
	width: 100%;
	max-width: 100%;
	overflow: hidden;
}

.calendar-weekdays {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 1px;
	margin-bottom: 8px;
	width: 100%;
	max-width: 100%;
}

.calendar-weekday {
	text-align: center;
	font-size: 0.75rem;
	font-weight: 600;
	color: #6b7280;
	padding: 4px 2px;
}

.calendar-days {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 2px;
	width: 100%;
	max-width: 100%;
}

.calendar-day {
	aspect-ratio: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	position: relative;
	cursor: pointer;
	border-radius: 6px;
	transition: all 0.2s ease;
	min-height: 50px;
	background: rgba(255, 255, 255, 0.02);
	padding: 4px;
	box-sizing: border-box;
	overflow: hidden;
	width: 100%;
	max-width: 100%;
}

.calendar-day:hover {
	background: rgba(255, 255, 255, 0.1);
}

.calendar-day.other-month {
	opacity: 0.3;
}

.calendar-day.today {
	background: rgba(59, 130, 246, 0.2);
	border: 1px solid rgba(59, 130, 246, 0.4);
}

.calendar-day.has-contracts {
	background: rgba(34, 197, 94, 0.1);
}

.day-number {
	font-size: 1rem;
	font-weight: 600;
	color: #374151;
	margin-bottom: 4px;
}

.contract-dots {
	display: flex;
	gap: 2px;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;
}

.contract-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: #3b82f6;
}

.more-contracts {
	font-size: 0.65rem;
	color: #6b7280;
	margin-left: 2px;
	font-weight: 500;
}

.calendar-tooltip {
	position: fixed;
	background: rgba(0, 0, 0, 0.9);
	color: white;
	padding: 8px 12px;
	border-radius: 6px;
	font-size: 0.875rem;
	z-index: 1000;
	pointer-events: none;
	transform: translateX(-50%) translateY(-100%);
	white-space: nowrap;
	max-width: 200px;
	overflow: hidden;
	text-overflow: ellipsis;
}

.calendar-tooltip::after {
	content: '';
	position: absolute;
	top: 100%;
	left: 50%;
	transform: translateX(-50%);
	border: 5px solid transparent;
	border-top-color: rgba(0, 0, 0, 0.9);
}

/* Calendar Loader Styles */
.calendar-loader {
	height: 300px;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.02);
	border-radius: 8px;
}

.calendar-skeleton {
	width: 100%;
	max-width: 300px;
	margin-bottom: 1rem;
}

.skeleton-calendar-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1rem;
}

.skeleton-nav-btn {
	width: 32px;
	height: 32px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 50%;
}

.skeleton-month-title {
	width: 120px;
	height: 24px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-weekdays {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 2px;
	margin-bottom: 8px;
}

.skeleton-weekday {
	height: 20px;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.2) 25%, rgba(128, 128, 128, 0.4) 50%, rgba(128, 128, 128, 0.2) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 4px;
}

.skeleton-calendar-grid {
	display: grid;
	grid-template-columns: repeat(7, 1fr);
	gap: 2px;
}

.skeleton-calendar-day {
	aspect-ratio: 1;
	background: linear-gradient(90deg, rgba(128, 128, 128, 0.1) 25%, rgba(128, 128, 128, 0.3) 50%, rgba(128, 128, 128, 0.1) 75%);
	background-size: 200% 100%;
	animation: skeleton-shimmer 2s infinite;
	border-radius: 6px;
	min-height: 40px;
}

.skeleton-calendar-day:nth-child(odd) {
	animation-delay: 0.1s;
}

.skeleton-calendar-day:nth-child(even) {
	animation-delay: 0.05s;
}

.calendar-nav-btn:disabled {
	opacity: 0.5;
	cursor: not-allowed;
}

/* Responsive calendar */
@media (max-width: 768px) {
	.calendar-widget {
		padding: 0.75rem;
		margin-top: 0.5rem;
	}

	.calendar-day {
		min-height: 35px;
		padding: 2px;
	}

	.day-number {
		font-size: 0.75rem;
	}

	.contract-dot {
		width: 5px;
		height: 5px;
	}

	.contract-dots {
		gap: 1px;
	}

	.more-contracts {
		font-size: 0.6rem;
	}

	.calendar-weekday {
		padding: 2px 1px;
		font-size: 0.65rem;
	}

	.calendar-days {
		gap: 1px;
	}

	.calendar-loader {
		height: 250px;
	}

	.skeleton-calendar-day {
		min-height: 30px;
	}

	.skeleton-nav-btn {
		width: 28px;
		height: 28px;
	}

	.skeleton-month-title {
		width: 100px;
		height: 20px;
	}

	.skeleton-weekday {
		height: 16px;
	}
}

/* Calendar Overlay Styles */
.calendar-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.7);
	backdrop-filter: blur(4px);
	z-index: 1050;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: fadeIn 0.3s ease;
}

.calendar-overlay-content {
	background: white;
	border-radius: 12px;
	box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
	max-width: 500px;
	width: 90%;
	max-height: 80vh;
	overflow: hidden;
	animation: slideIn 0.3s ease;
}

.overlay-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1.5rem;
	border-bottom: 1px solid #e5e7eb;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	color: white;
}

.overlay-title {
	margin: 0;
	font-size: 1.25rem;
	font-weight: 600;
	display: flex;
	align-items: center;
	color: white;
}

.overlay-close-btn {
	background: none;
	border: none;
	color: white;
	font-size: 1.25rem;
	cursor: pointer;
	padding: 0.5rem;
	border-radius: 6px;
	transition: background-color 0.2s ease;
}

.overlay-close-btn:hover {
	background: rgba(255, 255, 255, 0.1);
}

.overlay-body {
	padding: 1.5rem;
	max-height: 60vh;
	overflow-y: auto;
}

.client-list {
	display: flex;
	flex-direction: column;
	gap: 0.75rem;
}

.client-item {
	display: flex;
	align-items: center;
	padding: 1rem;
	border: 1px solid #e5e7eb;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	background: #f9fafb;
}

.client-item:hover {
	border-color: #3b82f6;
	background: white;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
	transform: translateY(-1px);
}

.client-info {
	display: flex;
	align-items: center;
	width: 100%;
	gap: 1rem;
}

.client-type-indicator {
	width: 12px;
	height: 12px;
	border-radius: 50%;
	flex-shrink: 0;
}

.client-details {
	flex: 1;
	min-width: 0;
}

.client-name {
	margin: 0 0 0.25rem 0;
	font-size: 1rem;
	font-weight: 600;
	color: #1f2937;
}

.client-meta {
	color: #6b7280;
	font-size: 0.875rem;
	margin: 0;
}

/* Overlay Animations */
@keyframes fadeIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateY(-20px) scale(0.95);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

/* Responsive overlay */
@media (max-width: 768px) {
	.calendar-overlay-content {
		width: 95%;
		margin: 1rem;
	}

	.overlay-header {
		padding: 1rem;
	}

	.overlay-title {
		font-size: 1.125rem;
	}

	.overlay-body {
		padding: 1rem;
	}

	.client-item {
		padding: 0.75rem;
	}
}
</style>
